import { useQuery } from "react-query";
import { getDocs } from "../requests/getDocs";

export default function useGetDocs(dealerId: string) {
  return useQuery({
    queryKey: ["dealer", { dealerId }],
    queryFn: () => getDocs(dealerId),
    refetchOnWindowFocus: false,
    enabled: Boolean(dealerId),
  });
}
